import { ComponentType } from '../../../cms/registries/types/propTypes';
import { ProductCarousalProps } from '../../../components/ProductCarousal/types/propsType';
import { CMSDataType } from '../../../utils/common';
const transformProductCarousal = (data: CMSDataType): ProductCarousalProps => {
  const productCarousal = Array.isArray(data?.product_carousel) ? data?.product_carousel[0] : data?.product_carousel;
  const products = productCarousal?.products?.map((p: CMSDataType) => ({
    productId: p.product_id,
    isBundle: p.is_bundle,
  }));
  const { end_time, title } = productCarousal?.countdowntimer ?? {};
  const aprContainerKey = productCarousal?.apr_container_key;
  const pageName = productCarousal?.page_name;

  return {
    componentType: ComponentType.product_carousel,
    products: products ?? [],
    title: productCarousal.display_title,
    type: productCarousal.type,
    backgroundColor: productCarousal.background_color,
    themeColor: productCarousal.theme_color?.color,
    countdownTimer: { endTime: end_time, title },
    aprContainerKey: aprContainerKey,
    pageName: pageName,
  };
};

export default transformProductCarousal;
